export var ThemeOptions;
(function (ThemeOptions) {
    ThemeOptions["DARK"] = "dark";
    ThemeOptions["LIGHT"] = "light";
})(ThemeOptions || (ThemeOptions = {}));
export var DeviationViewMode;
(function (DeviationViewMode) {
    DeviationViewMode["Theater"] = "theater";
    DeviationViewMode["Fullscreen"] = "fullscreen";
    DeviationViewMode["Normal"] = "regular";
})(DeviationViewMode || (DeviationViewMode = {}));
//# sourceMappingURL=types.js.map